/* eslint-disable react/jsx-props-no-spreading */
import { ButtonLink as CDSButtonLink } from '@coop/cds-components';

type ButtonLinkBaseProps = React.ComponentProps<typeof CDSButtonLink>;

export type ButtonLinkProps = {
    /**
     * If true, performs a hard navigation (full page reload) to the href URL.
     */
    hardNavigate?: boolean;
} & ButtonLinkBaseProps;

const ButtonLink = (props: ButtonLinkProps) => {
    return (
        <CDSButtonLink
            {...props}
            onClick={(e) => {
                if (props.hardNavigate && props.href) {
                    e.preventDefault(); // do not trigger soft (SPA) navigation
                    window.location.href = props.href;
                }

                props.onClick?.(e);
            }}
        >
            {props.children}
        </CDSButtonLink>
    );
};

export default ButtonLink;
